var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowPointToRight4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.462,
    height: 14.828,
    viewBox: "0 0 8.462 14.828",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-point-to-right",
    transform: "translate(0.001 0.024)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2632",
    "data-name": "Trazado 2632",
    d: "M97.441,8.132l6.368,6.368a1.037,1.037,0,0,0,1.467-1.467L99.641,7.4l5.634-5.634A1.037,1.037,0,1,0,103.809.3L97.441,6.666a1.036,1.036,0,0,0,0,1.467Z",
    transform: "translate(-97.138)",
    fill: "#acacac"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowPointToRight4);
export default __webpack_public_path__ + "static/media/arrow-point-to-right-4.7392618fcadecafc0cda4a690b51681c.svg";
export { ForwardRef as ReactComponent };